<template>
	<div class="entran">
		<Entrance></Entrance>
	</div>
</template>

<script>
	import Entrance from "../components/Home/entrAnce.vue"
	export default {
		name:'Entran',
		components: {
			Entrance
		}
	}
</script>
<style>

</style>
